import { DropdownNavigateKeys } from '@components/library/dropdown/index';

export const dropdownKeydownHelper = (
  keyPressed: DropdownNavigateKeys,
  optionsLength: number,
  targetedIndex: number,
): number | boolean => {
  switch (keyPressed) {
    case DropdownNavigateKeys.ArrowDown:
      if (targetedIndex > -1) {
        return (optionsLength > targetedIndex + 1) ? targetedIndex + 1 : 0;
      }
      return 0;
    case DropdownNavigateKeys.ArrowUp:
      if (targetedIndex > -1) {
        return targetedIndex === 0 ? optionsLength - 1 : targetedIndex - 1;
      }
      return optionsLength - 1;
    case DropdownNavigateKeys.Enter:
      if (targetedIndex > -1) {
        return true;
      }
      break;
    default:
      break;
  }

  return false;
};
